/* Country/language selector on touch devices (2026-09-21).
   iOS Safari does not give a link focus when you tap it, so the theme's own
   focusout handler closed the country list before the tap reached the option.
   The tap then landed on whatever sat underneath — the page appeared to jump.
   Here we ignore that focus loss and close the list on a real tap outside instead. */
(function () {
  function fix(root) {
    var forms = (root || document).querySelectorAll('localization-form');
    for (var i = 0; i < forms.length; i++) {
      (function (lf) {
        if (lf.dataset.ccLocFix) return;
        lf.dataset.ccLocFix = '1';
        var btn = lf.querySelector('button');
        if (btn) {
          btn.addEventListener('focusout', function (e) {
            if (e.relatedTarget === null) e.stopImmediatePropagation();
          }, true);
        }
        document.addEventListener('touchstart', function (e) {
          if (lf.hasAttribute('open') && !lf.contains(e.target)) {
            lf.removeAttribute('open');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        }, { passive: true });
      })(forms[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fix(document); });
  } else {
    fix(document);
  }
  document.addEventListener('shopify:section:load', function (e) { fix(e.target); });
})();
